import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Plus, ArrowUpRight, Pencil, Trash2 } from 'lucide-react';

const IncomeListTab = ({ income, formatCurrency, onAddIncome, onEditIncome, onDeleteIncome }) => (
  <Card>
    <CardHeader className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <CardTitle>Income</CardTitle>
        <CardDescription>Track revenue and other income</CardDescription>
      </div>
      <Button onClick={onAddIncome} className="bg-[#0A2B1D] hover:bg-[#254D3D] rounded-sm">
        <Plus className="w-4 h-4 mr-2" /> Add Income
      </Button>
    </CardHeader>
    <CardContent>
      {income.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <ArrowUpRight className="w-12 h-12 mx-auto mb-3 text-gray-300" />
          <p>No income recorded for this period</p>
          <p className="text-sm mt-1">Add income manually or connect your bank</p>
        </div>
      ) : (
        <div className="overflow-x-auto -mx-6 px-6">
          <table className="w-full min-w-[600px]">
            <thead>
              <tr className="border-b text-left">
                <th className="pb-3 font-medium text-gray-600">Date</th>
                <th className="pb-3 font-medium text-gray-600">Category</th>
                <th className="pb-3 font-medium text-gray-600">Description</th>
                <th className="pb-3 font-medium text-gray-600">Source</th>
                <th className="pb-3 font-medium text-gray-600 text-right">Amount</th>
                <th className="pb-3 font-medium text-gray-600 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {income.map((inc) => (
                <tr key={inc.id} className="border-b hover:bg-gray-50">
                  <td className="py-3 text-sm">{inc.date}</td>
                  <td className="py-3">
                    <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                      {inc.category_name}
                    </span>
                  </td>
                  <td className="py-3 text-sm">{inc.description}</td>
                  <td className="py-3 text-sm text-gray-500">{inc.source || '-'}</td>
                  <td className="py-3 text-right font-medium text-green-600">
                    {formatCurrency(inc.amount)}
                  </td>
                  <td className="py-3 text-right flex items-center justify-end gap-1">
                    <Button 
                      variant="ghost" 
                      size="sm"
                      className="text-[#5C6661] hover:text-[#0A2B1D] h-8 w-8 p-0"
                      onClick={() => onEditIncome(inc, 'income')}
                      data-testid={`edit-income-${inc.id}`}
                    >
                      <Pencil className="w-4 h-4" />
                    </Button>
                    <Button 
                      variant="ghost" 
                      size="sm"
                      className="text-red-600 hover:text-red-700 h-8 w-8 p-0"
                      onClick={() => onDeleteIncome(inc.id)}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-gray-50">
                <td colSpan={4} className="py-3 font-semibold">Total</td>
                <td className="py-3 text-right font-bold text-green-600">
                  {formatCurrency(income.reduce((sum, i) => sum + i.amount, 0))}
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </CardContent>
  </Card>
);

export default IncomeListTab;
